<template>
  <div class="messages tab-content">
    <el-tabs activeName="first">
      <el-tab-pane :label="$t('project_tab_messages_first')" name="first">
        <el-card>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-button @click="selectCurrentTabComponent('MessagesNew')" class="messages__btn" type="info" size="small" :plain="!(currentTabComponent == 'MessagesNew')"><i class="fas fa-envelope"></i> {{$t('project_tab_messages_first_btn_new')}}</el-button><br>
              <el-button @click="selectCurrentTabComponent('MessagesSent')" class="messages__btn" type="primary" size="small" :plain="!(currentTabComponent == 'MessagesSent')"><i class="far fa-envelope-open"></i> {{$t('project_tab_messages_first_btn_sent')}}</el-button><br>
              <el-button @click="selectCurrentTabComponent('MessagesReceived')" class="messages__btn" type="primary" size="small" :plain="!(currentTabComponent == 'MessagesReceived')"><i class="fas fa-envelope-open-text"></i> {{$t('project_tab_messages_first_btn_received')}}</el-button><br>
              <el-button @click="selectCurrentTabComponent('MessagesDeleted')" class="messages__btn" type="primary" size="small" :plain="!(currentTabComponent == 'MessagesDeleted')"><i class="fas fa-trash"></i> {{$t('project_tab_messages_first_btn_deleted')}}</el-button>
            </el-col>
            <el-col :span="20">
              <component :type="type" @reply="reply" :list="list" :isReply="isReply" :activeProjectId="activeProjectId" @turnOffIsReplay="turnOffIsReplay" :selectedRow="selectedRow" v-bind:is="currentTabComponent"></component>
            </el-col>
          </el-row>

          <!-- <div class="messages__header">
            <el-button @click="selectCurrentTabComponent('MessagesNew')" class="messages__new" type="primary" size="mini" :plain="!(currentTabComponent == 'MessagesNew')"><i class="fas fa-envelope"></i> New</el-button>
            <el-button @click="selectCurrentTabComponent('MessagesSent')" class="messages__sent" type="primary" size="mini" :plain="!(currentTabComponent == 'MessagesSent')"><i class="far fa-envelope-open"></i> Sent</el-button>
            <el-button @click="selectCurrentTabComponent('MessagesReceived')" class="messages__received" type="primary" size="mini" :plain="!(currentTabComponent == 'MessagesReceived')"><i class="fas fa-envelope-open-text"></i> Received</el-button>
            <el-button @click="selectCurrentTabComponent('MessagesDeleted')" class="messages__deleted" type="primary" size="mini" :plain="!(currentTabComponent == 'MessagesDeleted')"><i class="fas fa-trash"></i> Deleted</el-button>
          </div> -->

          <!-- <keep-alive> -->
            <!-- <component :type="type" @reply="reply" :list="list" :isReply="isReply" :activeProjectId="activeProjectId" @turnOffIsReplay="turnOffIsReplay" :selectedRow="selectedRow" v-bind:is="currentTabComponent"></component> -->
          <!-- </keep-alive> -->
        </el-card>
      </el-tab-pane>
    </el-tabs>
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div>-->
<!--        <div v-if="bookmarkList.messages" @click="changeBookMark(bookmarkList.messages, $route.query.companyId, selectedRow.projectId || selectedRow.businessUnitId || selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.messages, $route.query.companyId, selectedRow.projectId || selectedRow.businessUnitId || selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import axios from 'axios';
import MessagesReceived from '@/components/Projects/messages/MessagesReceived.vue'
import MessagesNew from '@/components/Projects/messages/MessagesNew.vue'
import MessagesSent from '@/components/Projects/messages/MessagesSent.vue'
import MessagesDeleted from '@/components/Projects/messages/MessagesDeleted.vue'

export default {
  components: {
    MessagesReceived,
    MessagesNew,
    MessagesSent,
    MessagesDeleted,
  },
  props: ['type', 'activeProjectId', 'selectedRow', 'bookmarkList'],
  data() {
    return {
      activeStar: 'el-icon-star-on',
      notActiveStar: 'el-icon-star-off',
      projectId: null,
      currentTabComponent: 'MessagesReceived',
      list: null,
      isReply: false
    }
  },
  methods: {
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    changeBookMark(state, companyid, projectId, taskId){
      let url = ''
      if (this.type == 'task') {
        url = `/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`
      } else if (this.type == 'taskBusinessUnit') {
        url = `/api/v1/bookmarks/setBusinessUnitTask?companyId=${companyid}&businessUnitId=${projectId}&businessUnitTaskId=${taskId}`
      }else if (this.type == 'taskEngagement') {
        url = `/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${projectId}&engagementTaskId=${taskId}`
      }
      let data = this.bookmarkList
      data.messages = !this.bookmarkList.messages
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(url, data)
              .then(response => {
                if (this.bookmarkList.messages) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
    },
    reply(list) {
      this.list = list
      this.isReply = true
      this.currentTabComponent = 'MessagesNew'
    },
    turnOffIsReplay(){
      this.isReply = false
      this.selectCurrentTabComponent('MessagesSent')
    },
    selectCurrentTabComponent(name) {
      switch (name) {
        case 'MessagesReceived':
          this.currentTabComponent = 'MessagesReceived'
          if (this.type == 'task') {
            this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          } else if (this.type == 'taskBusinessUnit') {
            this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          }else if (this.type == 'taskEngagement') {
            this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          }
          break;
        case 'MessagesNew':
          this.list = null
          this.isReply = false
          this.currentTabComponent = 'MessagesNew'
          break;
        case 'MessagesSent':
          this.currentTabComponent = 'MessagesSent'
          if (this.type == 'task') {
            this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
          } else if (this.type == 'taskBusinessUnit') {
            this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
          }else if (this.type == 'taskEngagement') {
            this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '2'})
          }
          break;
        case 'MessagesDeleted':
          this.currentTabComponent = 'MessagesDeleted'
          if (this.type == 'task') {
            this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '3'})
          } else if (this.type == 'taskBusinessUnit') {
            this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeProjectId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '3'})
          }else if (this.type == 'taskEngagement') {
            this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeProjectId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '3'})
          }
          break;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.messages {
  &__btn {
    width: 100%;
    margin-bottom: 5px;
  }
  &__header {
    display: flex;
    padding-bottom: 20px;
    color: #888;
    .font-color {
      color: #302f2f;
    }
    div {
      margin-right: 15px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
